import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const JoinWaitlistIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Join Waitlist`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M10.5 5.25a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm0 1.5a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM3 12.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h2Zm7.5-4.5a.75.75 0 0 1 .75.75v1.25h1.25a.75.75 0 0 1 0 1.5h-1.25v1.25a.75.75 0 0 1-1.5 0v-1.25H8.5a.75.75 0 0 1 0-1.5h1.25V8.5a.75.75 0 0 1 .75-.75ZM4 7.25a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h3Zm11-5a.75.75 0 0 1 0 1.5H1a.75.75 0 0 1 0-1.5h14Z"
    />
  </Icon>
);
